import { render, staticRenderFns } from "./recommendSwiper.vue?vue&type=template&id=7e20d86c&scoped=true&"
import script from "./recommendSwiper.vue?vue&type=script&lang=js&"
export * from "./recommendSwiper.vue?vue&type=script&lang=js&"
import style0 from "./recommendSwiper.vue?vue&type=style&index=0&id=7e20d86c&lang=sass&scoped=true&"
import style1 from "./recommendSwiper.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20d86c",
  null
  
)

export default component.exports